import React, { useState, useEffect, useRef } from 'react'
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { useFormik, FormikProvider, FieldArray } from 'formik';
import * as Yup from "yup";
import { FocusError } from 'focus-formik-error';
import { format } from 'date-fns';
import Api from '../../../../Api';
import { AdminTraficDetailsSchema } from '../../../../ValidationScema';
import { adminMainUrl } from '../../../../Config';
import Modal from 'react-bootstrap/Modal';
import { getChargehead } from '../../../../Redux/action/MasterAction';
import { useDispatch, useSelector } from 'react-redux';

const OceanTarrifDetailsModal = ({ handleShow, handleClose, show, modalData, rate, addTableId, tableDetailsId, tableId, modal, traficDetails, setUpdateTraficDetails, updateTraficDetails, loadingShipline, shiplineOptions }) => {
    const closeButtonRef = useRef(null);
    const dispatch = useDispatch();
    const [currentRowData, setCurrentRowData] = useState(null);
    const [weightUnit, setWeightUnit] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [tableIdData, setTableIdData] = useState(1)
    const [cargoType, setCargoType] = useState([]);
    const [chargeHeadOptions, setChargeHeadOptions] = useState([]);

    const matchingDetail = modalData.find(detail => detail.tableId === tableId);

    // Get the airline code if both conditions are met (data exists and tableId matches)
    const initialAirlineCode = matchingDetail ? matchingDetail.airline_code : ''; // Set as empty string if no data
    const GetWeightUnit = async () => {
        try {
            const data = await Api(`${adminMainUrl}/api/weight-unit/get`, "GET");
            const options = data?.data
                ?.filter((item) => item.status === true).map((item) => ({
                    WeightUnitId: item.id,
                    value: item.name,
                    label: item.name,
                }));
            setWeightUnit(options);
        } catch (error) {
            setWeightUnit([]);

            console.error("Error fetching data:", error);
        }
    };
    const GetCargoType = async () => {
        try {
            const data = await Api(`${adminMainUrl}/api/cargo-type/get`, "GET");
            const options = data?.data?.map(item => ({
                cargoId: item.id,
                value: item.name,
                label: item.name,
            }));
            setCargoType(options);

        } catch (error) {
            setCargoType([]);

            console.error("Error fetching data:", error);
        }
    };


    useEffect(() => {
        dispatch(getChargehead());
    }, []);

    const {
        loadingChargehead,
        chargeheadData,
        chargeheadDataError,
    } = useSelector(state => state?.MasterReducer);

    useEffect(() => {
        if (chargeheadData) {
            let arr = [];
            chargeheadData.map(val => { if (val.status) { arr.push({ value: val.name, label: val.name }) } });
            setChargeHeadOptions(arr);
        }
    }, [loadingChargehead, chargeheadData])

    const chargeHead = [
        { value: 'A/F', label: 'A/F' },
        { value: 'SSC', label: 'SSC' },
        { value: 'FSC', label: 'FSC' },
        { value: 'XRAY', label: 'XRAY' },
        { value: 'MISC', label: 'MISC' },
        { value: 'AMS', label: 'AMS' },
        { value: 'EXTRA', label: 'EXTRA' },
    ]

    const options = [
        { value: 'AI- Air India', label: 'AI- Air India' },
        { value: 'IX- Air India Express', label: 'IX- Air India Express' },
        { value: 'G8- Go First', label: 'G8- Go First' },
        { value: '6E- IndiGo', label: '6E- IndiGo' },
        { value: 'SG- SpiceJet', label: 'SG- SpiceJet' },
        { value: 'UK- Vistara', label: 'UK- Vistara' },
        { value: 'I7- IndiaOne Air', label: 'I7- IndiaOne Air' },
        { value: 'ZO- Zooom Air', label: 'ZO- Zooom Air' },
    ];

    const modalRef = useRef(null);
    const handleEditClick = (detail) => {
        if (modalRef.current) {
            modalRef.current.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
        setCurrentRowData(detail);
    };

    const formik = useFormik({
        initialValues: {
            // airline_code: "", // Pre-fill airline_code if available, otherwise empty
            // charge_head: '',
            // buying_price: '',
            // selling_price: '',
            // narration: '',
            // valid_upto: '',
            // currency: '',
            // exchange_rate: '',
            // unit_id: '',
            // fc_amount: '',
            // rate: '',
            // cargo_type_id: '',
            airline_code: "", // Pre-fill airline_code if available, otherwise empty
            charge_head: '',
            buying_price: '',
            base_price: '',
            // selling_price: '',
            narration: '',
            valid_upto: '',
        },
        validationSchema: Yup.object({
            airline_code: Yup.string().required('Please enter shipline code '),
            charge_head: Yup.string().required('Please enter charge head '),
            buying_price: Yup.number().required('Please enter buying price '),
            base_price: Yup.number().required('Please enter base price '),
            narration: Yup.string().required('Please enter narration '),
        }),
        onSubmit: (values, { resetForm }) => {
            setIsSubmitting(true);
            values.tableId = tableId;
            setTableIdData(values.tableId);
            // closeButtonRef.current.click();
            handleClose()
            if (currentRowData) {
                const updatedDetails = updateTraficDetails.map((detail) =>
                    detail === currentRowData ? { ...values, valid_upto: values.valid_upto.split('T')[0] } : detail
                );
                setUpdateTraficDetails(updatedDetails);
                setCurrentRowData(null);
                setIsSubmitting(false);
            } else {
                setUpdateTraficDetails([...updateTraficDetails, values]);
                setIsSubmitting(false);
            }

            resetForm({
                values: {
                    ...formik.initialValues, // Reset all fields to initial values
                    airline_code: formik.values.airline_code, // Preserve the airline_code
                },
            });
        },
    });
    // useEffect(() => {
    //   if (initialAirlineCode) {
    //     formik.setValues(initialAirlineCode);
    //   }
    // }, [initialAirlineCode]);
    useEffect(() => {
        if (rate?.length > 0 && rate[0].quote_tarrif) {
            setUpdateTraficDetails(rate[0].quote_tarrif);
        }
    }, [rate]);
    useEffect(() => {
        if (currentRowData) {
            formik.setValues(currentRowData);
        }
    }, [currentRowData]);
    const handleDeleteClick = (index) => {
        const updatedDetails = updateTraficDetails.filter((_, i) => i !== index);
        closeButtonRef.current.click();
        setUpdateTraficDetails(updatedDetails);
    };
    useEffect(() => {
        GetCargoType();
        GetWeightUnit();
    }, []);
    const groupedData = updateTraficDetails.reduce((acc, detail) => {
        if (!acc[detail.airline_code]) {
            acc[detail.airline_code] = [];
        }
        acc[detail.airline_code].push(detail);
        return acc;
    }, {});
    return (
        <>

            <Modal show={show} onHide={handleClose}
                size="xl"
                backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>New Rate</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="main_detail_form " id="main_id_sec">
                        <form onSubmit={formik.handleSubmit}>
                            <FocusError formik={formik} />
                            <div className="Air_Export_Form_bg">
                                <div className="Air_Export_bg_main">
                                    <div className="row">
                                        <div className="col-lg-3 col-md-6 col-12">
                                            <div className="">
                                                <label className='form-label'>Shipline Code & Name <span>*</span></label>
                                                {/* <input
                                                    className='form-control form-control-sm'
                                                    maxLength={2}
                                                    type="text"
                                                    placeholder="Enter airline code"
                                                    value={initialAirlineCode || formik.values.airline_code || ''} // Display airline_code
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    name="airline_code"
                                                    disabled={!!initialAirlineCode} // Disable only if initialAirlineCode is present
                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        // Prevent space as the first character
                                                        if (inputValue.length === 0 && event.key === ' ') {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                /> */}
                                                <Select
                                                    disabled={!!initialAirlineCode}
                                                    className='custom-selector'
                                                    options={shiplineOptions}
                                                    isLoading={loadingShipline}
                                                    value={shiplineOptions.find(option => option.value === formik.values.airline_code) || null} // Control the value based on Formik's state
                                                    onChange={(selectedOption) => formik.setFieldValue("airline_code", selectedOption.value)} // Set the correct field in Formik
                                                    onBlur={formik.handleBlur}
                                                />
                                                {formik.touched.airline_code && formik.errors.airline_code ? (
                                                    <div className="error">{formik.errors.airline_code}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        {/* <div className="col-lg-3 col-md-6 col-12">
                                            <div className="input_box_section input_popup_rate">
                                                <label className='mb-0'>Airline Name <span>*</span></label>
                                                <input
                                                    className='form-control form-control-sm'
                                                    // maxLength={2}
                                                    type="text"
                                                    placeholder="Enter airline Name"
                                                // value={initialAirlineCode || formik.values.airline_code || ''} // Display airline_code
                                                // onChange={formik.handleChange}
                                                // onBlur={formik.handleBlur}
                                                // name="airline_code"
                                                // disabled={!!initialAirlineCode} // Disable only if initialAirlineCode is present
                                                // onKeyPress={(event) => {
                                                //     const inputValue = event.target.value;
                                                //     // Prevent space as the first character
                                                //     if (inputValue.length === 0 && event.key === ' ') {
                                                //         event.preventDefault();
                                                //     }
                                                // }}
                                                />
                                                {formik.touched.airline_code && formik.errors.airline_code ? (
                                                    <div className="error">{formik.errors.airline_code}</div>
                                                ) : null}
                                            </div>
                                        </div> */}
                                        <div className="col-lg-3 col-md-6 col-12">
                                            <div className="">
                                                <label className='form-label'>Charge Head <span>*</span></label>
                                                {/* <input
                                                    type="text"
                                                    className='form-control form-control-sm'
                                                    placeholder="Enter charge head"
                                                    value={formik.values.charge_head}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    name="charge_head"
                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        // Prevent space as the first character
                                                        if (inputValue.length === 0 && event.key === ' ') {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                /> */}
                                                <Select
                                                    className='custom-selector'
                                                    options={chargeHeadOptions}
                                                    value={chargeHeadOptions.find(option => option.value === formik.values.charge_head) || null} // Control the value based on Formik's state
                                                    onChange={(selectedOption) => formik.setFieldValue("charge_head", selectedOption.value)} // Set the correct field in Formik
                                                    onBlur={formik.handleBlur}
                                                />
                                                {formik.touched.charge_head && formik.errors.charge_head ? (
                                                    <div className="error">{formik.errors.charge_head}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-12">
                                            <div className="input_box_section input_popup_rate">
                                                <label className='form-label'>Buying Price </label>
                                                <input
                                                    className='form-control form-control-sm'
                                                    type="text"
                                                    placeholder="Enter buying price"
                                                    value={formik.values.buying_price}
                                                    onChange={(e) => {
                                                        const num = e.target.value.replace(/[^0-9]/g, '');
                                                        formik.setFieldValue('buying_price', num);
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    name="buying_price"
                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        // Prevent space as the first character
                                                        if (inputValue.length === 0 && event.key === ' ') {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik.touched.buying_price && formik.errors.buying_price ? (
                                                    <div className="error">{formik.errors.buying_price}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-12">
                                            <div className="input_box_section input_popup_rate">
                                                <label className='form-label'>Base Price </label>
                                                <input
                                                    className='form-control form-control-sm'
                                                    type="text"
                                                    placeholder="Enter base price"
                                                    value={formik.values.base_price}
                                                    onChange={(e) => {
                                                        const num = e.target.value.replace(/[^0-9]/g, '');
                                                        formik.setFieldValue('base_price', num);
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    name="base_price"
                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        // Prevent space as the first character
                                                        if (inputValue.length === 0 && event.key === ' ') {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik.touched.base_price && formik.errors.base_price ? (
                                                    <div className="error">{formik.errors.base_price}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        {/* <div className="col-lg-3 col-md-6 col-12">
                                            <div className="input_box_section input_popup_rate">
                                                <label className='mb-0'>Selling Price <span>*</span></label>
                                                <input
                                                    type="text"
                                                    className='form-control form-control-sm'
                                                    placeholder="Enter selling price"
                                                    value={formik.values.selling_price}
                                                    onChange={(e) => {
                                                        const num = e.target.value.replace(/[^0-9]/g, '');
                                                        formik.setFieldValue('selling_price', num);
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    name="selling_price"
                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        // Prevent space as the first character
                                                        if (inputValue.length === 0 && event.key === ' ') {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik.touched.selling_price && formik.errors.selling_price ? (
                                                    <div className="error">{formik.errors.selling_price}</div>
                                                ) : null}
                                            </div>
                                        </div> */}
                                        <div className="col-lg-3 col-md-6 col-12">
                                            <div className="input_box_section input_popup_rate">
                                                <label className='form-label'>Narration</label>
                                                <input
                                                    type="text"
                                                    className='form-control form-control-sm'
                                                    placeholder="Enter narration"
                                                    value={formik.values.narration}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    name="narration"
                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        // Prevent space as the first character
                                                        if (inputValue.length === 0 && event.key === ' ') {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik.touched.narration && formik.errors.narration ? (
                                                    <div className="error">{formik.errors.narration}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-12">
                                            <div className="input_box_section input_popup_rate">
                                                <label className='form-label'>Valid Upto <span>*</span></label>
                                                <DatePicker
                                                    className='form-control form-control-sm'
                                                    minDate={new Date()}
                                                    placeholderText='Enter valid upto'
                                                    style={{ width: '100%' }}
                                                    selected={formik.values.valid_upto}
                                                    onChange={(date) => {
                                                        const formattedDate = date.toISOString().split('T')[0];
                                                        formik.setFieldValue('valid_upto', formattedDate);
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    name="valid_upto"
                                                />
                                                {formik.touched.valid_upto && formik.errors.valid_upto ? (
                                                    <div className="error">{formik.errors.valid_upto}</div>
                                                ) : null}
                                            </div>
                                        </div>

                                        {/* <div className="col-md-12">
                          <div className="info-det-button-add">
                            <button type="button" onClick={() => formik.setFieldValue('tarrif_details', [...formik.values.tarrif_details, {}])}>
                              + Add
                            </button>
                          </div>
                        </div> */}
                                        <div className="col-md-12">
                                            <button className="btn btn-primary" type="submit" disabled={isSubmitting}>
                                                {isSubmitting ? <div><i className="fa fa-spinner fa-spin" /> Submit</div> : "Submit"}
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div className="Air_Export_Form_bg">
                            <div className="Air_Export_bg_main">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="table_detail_tariff table-responsive">
                                            {/* <table className="posts-table geeks">
                            <thead>
                              <tr className="users-table-tariff n_detail_comp">
                                <th>Shipline Code</th>
                                <th>Charge Head</th>
                                <th>Buyer Amount</th>
                                <th>Seller Amount</th>
                                <th>Narration</th>
                                <th>Valid Up To</th>
                                <th>Currency</th>
                                <th>Exchange Rate</th>
                                <th>Unit</th>
                                <th>FC Amount</th>
                                <th>Rate</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {updateTraficDetails.map((detail, index) => (

                                <tr key={index} className="main_table_row_new n_detail_comp">
                                  <td>{detail.airline_code}</td>
                                  <td>{detail.charge_head}</td>
                                  <td>{detail.buying_price}</td>
                                  <td>{detail.selling_price}</td>
                                  <td>{detail.narration}</td>
                                  <td>{detail.valid_upto}</td>
                                  <td>{detail.currency}</td>
                                  <td>{detail.exchange_rate}</td>
                                  <td>{detail.unit}</td>
                                  <td>{detail.fc_amount}</td>
                                  <td>{detail.rate}</td>
                                  <td>
                                    <div className="main_icon_click">
                                      <div ref={modalRef} style={{ cursor: "pointer" }} onClick={() => handleEditClick(detail)}>
                                        <img src="/img/edit-line.png" alt="edit" />
                                      </div>
                                      <div style={{ cursor: "pointer" }} onClick={() => handleDeleteClick(index)}>
                                        <img src="/img/delete-outline.png" alt="delete" />
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                              {
                                updateTraficDetails.map((detail, indexData) => {
                                  // tableDetailsId = detail.tableId;

                                  // Check the condition for matching tableId and return the row
                                  if (tableId === detail.tableId) {
                                    return (
                                      <tr key={indexData} className="main_table_row_new n_detail_comp">
                                        <td>{detail.airline_code}</td>
                                        <td>{detail.charge_head}</td>
                                        <td>{detail.buying_price}</td>
                                        <td>{detail.selling_price}</td>
                                        <td>{detail.narration}</td>
                                        <td>{detail.valid_upto}</td>
                                        <td>{detail.currency}</td>
                                        <td>{detail.exchange_rate}</td>
                                        <td>{detail.unit}</td>
                                        <td>{detail.fc_amount}</td>
                                        <td>{detail.rate}</td>
                                        <td>
                                          <div className="main_icon_click">
                                            <div style={{ cursor: "pointer" }} onClick={() => handleEditClick(detail)}>
                                              <img src="/img/edit-line.png" alt="edit" />
                                            </div>
                                            <div style={{ cursor: "pointer" }} onClick={() => handleDeleteClick(indexData)}>
                                              <img src="/img/delete-outline.png" alt="delete" />
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  } else {
                                    return null; // Return null if the condition doesn't match
                                  }
                                })
                              }

                            </tbody>
                          </table> */}
                                            <table className="posts-table geeks w-100">
                                                <thead>
                                                    <tr className="users-table-tariff n_detail_comp">
                                                        <th>Shipline Code & Name</th>
                                                        <th>Charge Head</th>
                                                        <th>Buying Price</th>
                                                        <th>Base Price</th>
                                                        <th>Narration</th>
                                                        <th>Valid Upto</th>
                                                        <th>Action</th>
                                                        {/* <th>Currency</th>
                                                        <th>Exchange Rate</th>
                                                        <th>Unit ID</th>
                                                        <th>FC Amount</th>
                                                        <th>Rate</th>
                                                        <th>Action</th> */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {modalData?.length > 0 ? modalData.map((detail, indexData) => (
                                                        <tr key={indexData} className="main_table_row_new n_detail_comp">
                                                            <td>{detail.airline_code}</td>
                                                            <td>{detail.charge_head}</td>
                                                            <td>{detail.buying_price}</td>
                                                            <td>{detail.base_price}</td>
                                                            <td>{detail.narration}</td>
                                                            <td>{detail.valid_upto ? format(new Date(detail.valid_upto), 'dd/MM/yyyy') : 'N/A'}</td>
                                                            {/* <td>{detail.currency}</td>
                                                            <td>{detail.exchange_rate}</td>
                                                            <td>{detail.unit_id}</td>
                                                            <td>{detail.fc_amount}</td>
                                                            <td>{detail.rate}</td> */}
                                                            <td>
                                                                <td>
                                                                    <div className="main_icon_click">
                                                                        <div style={{ cursor: "pointer" }} onClick={() => handleEditClick(detail)}>
                                                                            <img src="/img/edit-line.png" alt="edit" />
                                                                        </div>
                                                                        <div style={{ cursor: "pointer" }} onClick={() => handleDeleteClick(indexData)}>
                                                                            <img src="/img/delete-outline.png" alt="delete" />
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </td>
                                                        </tr>
                                                    )) : (
                                                        <tr>
                                                            <td colSpan="12" className="text-center">No data available</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div></Modal.Body>
            </Modal>


        </>
    )
}

export default OceanTarrifDetailsModal